<template>
  <div class="nursing-center">
    <el-card class="info-card">
      <template #header>
        <div class="card-header">
          <el-button @click="$router.push('/dashboard')" type="primary" plain style="margin-right: 10px;">
            返回首页
          </el-button>
          <h2>衡水老年养护服务中心</h2>
        </div>
      </template>
      <div class="info-content">
        <div class="info-item">
          <el-icon><Location /></el-icon>
          <div class="info-text">
            <div class="label">地址：</div>
            <div class="value">河北省衡水市桃城区振远路</div>
          </div>
        </div>
        <div class="info-item">
          <el-icon><Phone /></el-icon>
          <div class="info-text">
            <div class="label">电话：</div>
            <div class="value">0318-5222666</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Location, Phone } from '@element-plus/icons-vue'

export default {
  name: 'NursingCenter',
  components: {
    Location,
    Phone
  }
}
</script>

<style scoped>
.nursing-center {
  padding: 20px;
}

.info-card {
  max-width: 800px;
  margin: 0 auto;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  margin: 0;
  color: #303133;
}

.info-content {
  padding: 20px 0;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item .el-icon {
  font-size: 24px;
  color: #409EFF;
  margin-right: 15px;
  margin-top: 2px;
}

.info-text {
  flex: 1;
}

.label {
  font-size: 16px;
  color: #606266;
  margin-bottom: 8px;
}

.value {
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}
</style> 